import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { storage } from "../lib/api";
import { Bone, ArrowRight } from "lucide-react";
import { useTranslation } from "react-i18next";

export default function MyCoupons() {
  const { t } = useTranslation();
  const [items, setItems] = useState([]);

  useEffect(() => {
    setItems(storage.getClaimed());
  }, []);

  return (
    <div className="max-w-5xl mx-auto px-4 lg:px-8 py-8" data-testid="mis-huesos-page">
      <header className="mb-8">
        <div className="font-mono text-[10px] uppercase tracking-widest text-[#FEBA01]">{t("myHuesos.eyebrow")}</div>
        <h1 className="mt-1 font-display text-5xl sm:text-6xl uppercase tracking-tighter leading-none">{t("myHuesos.title")}</h1>
        <p className="mt-3 text-[#A3A3A3]">{t("myHuesos.desc")}</p>
      </header>

      {items.length === 0 ? (
        <div className="border-2 border-dashed border-[#333] p-10 text-center">
          <Bone size={32} strokeWidth={2.2} className="mx-auto text-[#FEBA01] mb-3" />
          <p className="text-[#A3A3A3] font-mono uppercase text-xs tracking-widest">{t("myHuesos.emptyState")}</p>
          <Link to="/cupones" className="mt-4 inline-block btn-brutal bg-[#FEBA01] text-black font-display uppercase px-5 py-2 shadow-brutal-white" data-testid="mis-huesos-empty-cta">
            {t("myHuesos.emptyCta")}
          </Link>
        </div>
      ) : (
        <div className="grid sm:grid-cols-2 gap-4">
          {items.map((it) => (
            <Link
              key={it.id}
              to={`/cupones/${it.coupon_id}`}
              data-testid={`mi-hueso-${it.id}`}
              className="bg-[#1A1A1A] border-2 border-[#333] hover:border-[#FEBA01] p-4 group transition-colors"
            >
              <div className="font-mono text-[10px] uppercase tracking-widest text-[#FEBA01]">{it.claim_code}</div>
              <h3 className="mt-2 font-display text-2xl uppercase leading-none tracking-tight group-hover:text-[#FEBA01]">{it.title}</h3>
              <div className="mt-1 text-xs font-mono uppercase tracking-widest text-[#A3A3A3]">@ {it.venue_name}</div>
              <div className="mt-3 flex items-center justify-between">
                <div className="font-display text-xl text-[#FEBA01]">{it.discount}</div>
                <ArrowRight size={16} className="text-[#FEBA01]" />
              </div>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}
